import { useCallback, useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { Intersection } from "./intersection";

export function useActiveMobile(rootRef, enabled) {
	const [active, setActive] = useState(0);
	
	const handleIntersection = useCallback((entries) => {
		const activeCard = entries.find((e) => e.isIntersecting);

		if (!activeCard) return;

		const index = parseInt(activeCard.target.dataset.index);

		setActive(index);
	}, []);

	const intersection = useRef(new Intersection(rootRef, handleIntersection));

	const handleResize = useDebouncedCallback(() => {
		intersection.current.resetObserver();
	}, 200);

	useEffect(() => {
		if (!enabled) return;

		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [enabled]);

	useEffect(() => {
		if (enabled) {
			intersection.current.setOn(true);
		} else {
			intersection.current.setOn(false);
			intersection.current.detachNodes();
		}
	}, [enabled]);

	return active;
}
